var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayerFastBackward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "backwards",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.2,44.2v-2.3c0-0.4,0.2-0.8,0.6-1l6.2-3.7c0.2-0.1,0.4-0.2,0.6-0.2h2.8c0.7,0,1.2,0.5,1.2,1.2v24.3 c0,0.7-0.5,1.2-1.2,1.2h-2.5c-0.7,0-1.2-0.5-1.2-1.2V42.7c0-0.2-0.2-0.3-0.3-0.2L29,45.2C28.2,45.7,27.2,45.1,27.2,44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.6,50.3c0-4.2,0.8-7.6,2.5-10c1.7-2.5,4-3.7,7.1-3.7c3.1,0,5.4,1.2,7.1,3.7c1.7,2.5,2.5,5.8,2.5,10 c0,4.2-0.8,7.5-2.5,10c-1.6,2.5-4,3.8-7.2,3.8c-3,0-5.4-1.3-7.1-3.8C44.5,57.8,43.6,54.4,43.6,50.3z M49.9,43.4 c-0.8,1.6-1.2,3.9-1.2,6.9c0,3,0.4,5.3,1.2,6.9c0.8,1.6,1.9,2.4,3.3,2.4c1.5,0,2.6-0.8,3.4-2.4c0.8-1.6,1.2-3.9,1.2-6.9 c0-3-0.4-5.3-1.2-6.9c-0.8-1.6-2-2.4-3.4-2.4C51.8,41,50.7,41.8,49.9,43.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.6,21c0.9-0.6,3.2-1.7,4.2,0.1c1.2,2.1-0.3,3.4-0.8,3.7C21,30,15.7,39,15.7,49.3 c0,16.1,13.1,29.3,29.3,29.3s29.3-13.1,29.3-29.3c0-14.1-10-25.8-23.2-28.6v6.1c0,1-1.1,1.6-1.9,1.1L33.6,18 c-0.8-0.5-0.8-1.6,0-2.1l15.5-9.8c0.8-0.5,1.9,0.1,1.9,1.1v8.3c16.1,2.9,28.3,16.9,28.3,33.8c0,19-15.4,34.4-34.4,34.4 c-19,0-34.4-15.4-34.4-34.4C10.6,37.5,16.6,27.2,25.6,21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerFastBackward);
export default __webpack_public_path__ + "static/media/playerFastBackward.52056c72c8ca9ce2381bb9e8bff4cc7e.svg";
export { ForwardRef as ReactComponent };